import { useNavigate, useLocation } from 'react-router-dom'
import { useBuildStore } from '@/store/build-store'
import { useConfigStore } from '@/store/config-store'
import { calculateTotal, formatCurrency } from '@/lib/pricing'

export function MobilePriceBar() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { selectedModelId, selectedOptionIds } = useBuildStore()
  const { config } = useConfigStore()

  if (!config || !selectedModelId) return null

  const total = calculateTotal(selectedModelId, selectedOptionIds, config.models, config.options)
  const upgradeCount = selectedOptionIds.length
  const isReview = pathname.includes('/review')

  return (
    <div className="bg-dark-900 border-t border-dark-700 px-4 py-3 flex items-center justify-between">
      <div>
        <div className="text-brand-400 font-bold text-lg leading-none">{formatCurrency(total)}</div>
        <div className="text-slate-500 text-xs mt-0.5">
          {upgradeCount > 0 ? `${upgradeCount} upgrade${upgradeCount !== 1 ? 's' : ''}` : 'Base price'}
        </div>
      </div>
      {!isReview && (
        <button
          onClick={() => navigate('/build/review')}
          className="bg-brand-500 hover:bg-brand-600 text-white text-sm font-semibold px-4 py-2.5 rounded-lg transition-colors"
        >
          Review Build →
        </button>
      )}
    </div>
  )
}
